<template>

    <DeleteConfirmModal
      v-if="showDeleteModal"
      @confirm="handleDelete"
      @cancel="showDeleteModal = false"
    />
  <div class="languages-wrapper">
    <div class="languages-box">
      <h2>Dil Yönetimi</h2>

      <!-- Yeni dil ekleme -->
      <form @submit.prevent="addLanguage" class="form-row">
        <input v-model="newLanguage" placeholder="Yeni dil adı" required />
        <button class="btn blue">Ekle</button>
      </form>

<!-- Diller listesi -->
<div v-for="lang in languages" :key="lang.id" class="language-card">
  <div class="language-header" @click="toggleHatTurleri(lang.id)">
    <strong>{{ lang.name }}</strong>
    <div>
      <!-- OK önce, sadece görünür ama @click yok! -->
      <button
        v-if="lang.name === 'Osmanlıca'"
        class="btn toggle"
        @click.stop="toggleHatTurleri(lang.id)"
      >
        {{ activeLanguageId === lang.id ? '▲' : '▼' }}
      </button>

      <!-- Sil butonuna @click.stop ekli ama accordion'a tıklama vermiyor -->
      <button class="btn red" @click.stop="confirmDelete('language', lang.id)">Sil</button>
    </div>
  </div>
      

        <!-- Hat türleri: sadece Osmanlıca için -->
        <div
          v-if="lang.name === 'Osmanlıca' && activeLanguageId === lang.id"
          class="hat-section"
        >
          <h4 class="hat-title">Hat Türleri</h4>

          <ul class="hat-list">
            <li v-for="hat in hatTurleri" :key="hat.id" class="hat-item">
              <span>{{ hat.name }}</span>
              <button class="btn small red" @click="confirmDelete('hat', hat.id)">×</button>
            </li>
          </ul>

          <form @submit.prevent="addHatTur" class="form-row mt-2">
            <input
              v-model="newHatTur"
              placeholder="Yeni hat türü"
              class="hat-input"
              required
            />
            <button class="btn blue">+ Ekle</button>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'
import DeleteConfirmModal from '@/components/DeleteConfirmModal.vue'
const baseURL = process.env.VUE_APP_API_URL
const showDeleteModal = ref(false)
const itemToDelete = ref(null)
const deleteType = ref(null) // 'language' veya 'hat'

const languages = ref([])
const newLanguage = ref('')
const newHatTur = ref('')
const hatTurleri = ref([])
const activeLanguageId = ref(null)

// Dilleri getir
async function fetchLanguages() {
  const res = await fetch(`${baseURL}/admin/languages`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  if (res.ok) {
    languages.value = await res.json()
  }
}

// Hat türlerini getir
async function fetchHatTurleri() {
  const res = await fetch(`${baseURL}/admin/hat-turleri?language_id=1`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  if (res.ok) {
    hatTurleri.value = await res.json()
  }
}

// Yeni dil ekle
async function addLanguage() {
  if (!newLanguage.value) return
  const res = await fetch(`${baseURL}/admin/languages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({ name: newLanguage.value })
  })

  if (res.ok) {
    newLanguage.value = ''
    fetchLanguages()
  }
}

// Dil sil
async function deleteLanguage(id) {
  const res = await fetch(`${baseURL}/admin/languages/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })

  if (res.ok) {
    fetchLanguages()
  }
}
// Hat türü ekle
async function addHatTur() {
  const res = await fetch(`${baseURL}/admin/hat-turleri`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({ name: newHatTur.value, language_id: 1 })
  })

  if (res.ok) {
    newHatTur.value = ''
    fetchHatTurleri()
  }
}

// Hat türü sil
async function deleteHatTur(id) {
  const res = await fetch(`${baseURL}/admin/hat-turleri/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })

  if (res.ok) {
    fetchHatTurleri()
  }
}


// Accordion toggle
function toggleHatTurleri(id) {
  activeLanguageId.value = activeLanguageId.value === id ? null : id
  if (id === 1) fetchHatTurleri()
}
function confirmDelete(type, id) {
  deleteType.value = type
  itemToDelete.value = id
  showDeleteModal.value = true
}
async function handleDelete() {
  if (deleteType.value === 'language') {
    await deleteLanguage(itemToDelete.value)
  } else if (deleteType.value === 'hat') {
    await deleteHatTur(itemToDelete.value)
  }
  showDeleteModal.value = false
}
onMounted(fetchLanguages)
</script>



<style scoped>
/* Admin Layout */
.admin-layout {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

/* Sidebar */
.sidebar {
  position: relative;  /* fixed yerine relative kullanarak dinamik uzunluk sağlıyoruz */
  top: 60px;
  width: 220px;
  background: rgba(38, 55, 70, 0.493);
  color: #fff;
  overflow-y: auto;  /* Sidebar içinde scroll yapılabilmesi için */
  transition: width 0.3s ease;
  z-index: 10;
}

.sidebar.collapsed {
  width: 60px;
  background: none;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;  /* Menüyü en üste hizala */
  align-items: center;
  padding-top: 20px;
}

/* Sidebar Items */
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.sidebar li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
  color: #873f3f;
  justify-content: flex-start;
  padding-left: 16px;
}

.sidebar li:hover,
.sidebar li.active {
  background-color: rgba(186, 205, 222, 0.989);
}

.sidebar.collapsed li {
  justify-content: center;
  padding-left: 0;
}

.sidebar li.menu-toggle {
  margin-bottom: 40px;
  justify-content: center;
  color: black;
}

/* Sidebar Icon */
.sidebar li .icon {
  font-size: 18px;
}

/* Main Content */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 220px;
  min-height: 100%;
  transition: margin-left 0.3s ease;
}

.sidebar.collapsed + .main-content {
  margin-left: 60px;
}

/* Section Styles */
.section {
  padding: 30px;
  flex-grow: 1;
  padding-bottom: 80px; /* Space for footer */
}

/* Language Wrapper */
.languages-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 150px;
}

/* Language Box */
.languages-box {
  width: 100%;
  max-width: 700px;
  background: rgba(255, 255, 255, 0.95);
  color: #222;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #ddd;
  text-align: center;
}

.languages-box * {
  color: inherit;
}

/* Language Card */
.language-card {
  border: 1.5px solid #ccc;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fafafa;
  transition: box-shadow 0.2s;
  color: rgba(0, 0, 0, 0.877);
}

.language-card:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
}

.language-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Form Row */
.form-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

/* Form Input */
.form-row input {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
}

/* Hat Section */
.hat-section {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px dashed #bbb;
  text-align: center;
}

.hat-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.hat-list {
  list-style: none;
  padding: 0;
  margin-bottom: 12px;
  text-align: left;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.hat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0f0f0;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 15px;
  font-weight: bold;
}

/* Buttons */
.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.btn.blue {
  background-color: #3498db;
}

.btn.red {
  background-color: #e74c3c;
}

.btn.small {
  padding: 4px 8px;
  font-size: 12px;
}

.btn.toggle {
  background-color: transparent;
  color: #444;
  font-size: 16px;
}

@media (max-width: 768px) {
  .languages-wrapper {
    margin-top: 80px;
    padding: 0 12px;
  }

  .languages-box {
    padding: 20px 16px;
    text-align: left;
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;
  }

  .form-row input,
  .form-row button {
    width: 100%;
  }

  .language-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .hat-list {
    max-width: 100%;
  }

  .hat-item {
    font-size: 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .btn.small {
    font-size: 13px;
    padding: 6px 10px;
  }
}

</style>
